import React from 'react';
import ReactDOM from 'react-dom';
import './css/index.css';
import CreateSiteSearch from './components/createSiteSearch/createSiteSearch';
import SettingSiteSearch from './components/settingSiteSearch/settingSiteSearch';
import ConfirmSiteSearch from './components/confirmSiteSearch/confirmSiteSearch';
import reportWebVitals from './reportWebVitals';
import { HashRouter, Route, Switch} from 'react-router-dom';

ReactDOM.render(
  <HashRouter>
    <Switch>
      <Route path="/CreateSiteSearch" component={CreateSiteSearch} />
      <Route path="/SettingSiteSearch" component={SettingSiteSearch} />
      <Route path="/ConfirmSiteSearch" component={ConfirmSiteSearch} />
    </Switch>
  </HashRouter>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
